export default __webpack_public_path__ + "static/media/ZoneTypeC.7c5e8ef9.png";